import { formatPrice } from "../../../commons/utils/functions/formatPrice";
import { isIncludedSelectedVariant, isVariantSelected } from "../../../commons/utils/functions/product";
import styles from "./product-variants.module.scss";

interface ProductVariantsProps {
  attributes: ProductAttribute[];
  selectedVariants: SelectedVariant[];
  setSelectedVariant: (variant: SelectedVariant) => void;
}

const ProductVariants: React.FC<ProductVariantsProps> = ({
  attributes,
  selectedVariants,
  setSelectedVariant,
}: ProductVariantsProps) => {
  const renderLabelTooltip = (minOrder: number, maxOrder: number) => {
    if (minOrder === 0) {
      return <span>Optional{maxOrder && `, max ${maxOrder}`}</span>;
    } else if (minOrder >= maxOrder) {
      return <span>{`Pick ${minOrder}`}</span>;
    } else if (!minOrder && !maxOrder) {
      return <span>{`Pick 1`}</span>;
    }
    return <span>{`Pick ${minOrder}, max ${maxOrder}`}</span>;
  };

  return (
    <div className={styles.wrapper}>
      {attributes.map((attribute, index) => (
        <div className={styles.attribute} key={attribute.attribute_name}>
          <div className={styles.label}>
            {attribute.attribute_name} :{renderLabelTooltip(attribute.min!, attribute.max!)}
          </div>
          <div className={styles.variants}>
            {attribute.variants.map((variant: ProductVariation, indexVariant: number) => {
              const uniqueIndex = `${index}-${indexVariant}`;
              return (
                <div
                  className={[
                    styles.variant,
                    isVariantSelected({ ...variant, index: uniqueIndex }, selectedVariants) ? styles.active : "",
                  ].join(" ")}
                  key={variant.attribute_value}
                  onClick={() =>
                    setSelectedVariant({
                      ...variant,
                      attribute_name: attribute.attribute_name,
                      is_required: attribute.is_required,
                      is_multiple_choice: attribute.is_multiple_choice,
                      min: attribute.min!,
                      max: attribute.max!,
                      index: uniqueIndex,
                    })
                  }
                >
                  {variant.attribute_value}{" "}
                  <span className={styles.price}>{variant.price > 0 ? formatPrice(variant.price) : ""}</span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductVariants;
